import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';
import Divide from '~/components/Divide';
import Page from '~/components/layout/page/Page';
import PaymentFields from '~/components/PaymentFields';

export default function PaymentSummary<Amount extends { display: string }>({
  amount,
  headline = 'Payment Summary',
  label,
}: {
  amount: Amount;
  headline?: string;
  label: string;
}) {
  return (
    <Page.Section title={headline}>
      <Divide>
        <DescriptionList>
          <DescriptionListItem
            variant="sm"
            label={label}
            value={amount.display}
          />
        </DescriptionList>

        <PaymentFields />
      </Divide>
    </Page.Section>
  );
}
